module.exports = __webpack_public_path__ + "bof.png?c4d9c8cd0d212aa0feec31385eb74641";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bof.png
// module id = 146
// module chunks = 0